import { useEffect, useState } from 'react'
import { FONT_SIZES, getFontSize } from '../constants/theme'

export const useCardStack = cardEl => {
  const [asStacked, setAsStacked]: any = useState(null)

  const handleResize = () => {
    if (!cardEl || !cardEl.current) {
      return
    }
    let maxWidth
    switch (getFontSize().size) {
      case FONT_SIZES[1].size:
        maxWidth = 540
        break
      case FONT_SIZES[2].size:
        maxWidth = 620
        break
      default:
        maxWidth = 460
        break
    }
    if (cardEl.current.offsetWidth < maxWidth && !asStacked) {
      setAsStacked('asStacked')
    } else if (cardEl.current.offsetWidth >= maxWidth && asStacked) {
      setAsStacked(null)
    }
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    handleResize()
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return asStacked
}
